import { useEffect, type ReactNode } from 'react'
import { IconButton } from './button'

type Props = {
  title: string
  onClose: () => void
  children: ReactNode
  footer?: ReactNode
  width?: number
}

export function Drawer({ title, onClose, children, footer, width = 480 }: Props) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [onClose])

  return (
    <>
      <div className="drawer-scrim" onClick={onClose} />
      <aside className="drawer" style={{ width }}>
        <div className="drawer-head">
          <h2>{title}</h2>
          <div style={{ flex: 1 }} />
          <IconButton icon="x" onClick={onClose} tooltip="Закрити (Esc)" />
        </div>
        <div className="drawer-body">{children}</div>
        {footer && <div className="drawer-foot">{footer}</div>}
      </aside>
    </>
  )
}
